export default "__VITE_ASSET__D0IBr44A__"